"use client";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useAuth } from "@/store/auth";
import CreditBalanceTable from "./CreditBalanceTable";
import ReferralTable from "./ReferralTable";
import RecentBookingTable from "./RecentBookingTable";
import DashboardAnalytics from "./MetricCard";
import BookingTable from "./common/Table";
import { Accordion } from "./common/Accordian";
import { toast } from "react-toastify";
import {
  Inbox,
  Trash2,
  SquareCheckBig,
  Eye,
  Edit,
  User,
  ToggleRight,
  Users,
  CreditCard,
  RefreshCcw,
  SquarePen,
  TrendingUp,
} from "lucide-react";
import {
  useGetUserCreditTrancations,
  useGetUserWalletBalance,
  useGetReferralPoints,
  useGetRecentUserDetails,
  useBiddingMutation,
  useRecentBookingMutation,
  useAssignedBookingMutation,
  useUnAssignedBookingMutation,
  useVendorAcceptedJob,
  useDeleteRecentlyViewedMutation,
  useStatusRecentlyViewedMutation,
  useSendUserEmail,
  useUpdateBiddingStatus,
  useGetUseBookingCount,
  useGetDriverList,
  useGetDriverListRecent,
} from "@/hooks/useCommon";
import ClaimBookingModal from "@/components/ClaimBookingModal";
import TripDetailModal from "./TripDetailModal";
import UserStatusUpdateModal from "./UserStatusUpdateModal";
import RelationManagerModal from "./RelationManagerModal";
import { useBidFormStore } from "@/lib/BidFormContext";
import { useRouter } from "next/navigation";
import DashboardScore from "./DashboardScore";
import UserByCountry from "./UserByCountry";
import TopUsers from "./TopUsers";
import PerformanceAnalytics from "./PerformanceAnalytics";
import SourceWiseLeadScore from "./SourceWiseLeadScore";
import Link from "next/link";

interface BidListingRow {
  sno: number;
  sourceCity: string;
  destinationCity: string;
  distanceKm: number;
  vehicleType: string;
  package: string;
  packageMode: string;
  minCharge: number;
  minDistance: number;
  perKmCharge: number;
  startTime: string;
  endTime: string;
  fromDate: string;
  toDate: string;
  action: string;
  fare?: number;
  extraKm?: number;
  toll: number;
  parking: number;
  da: number;
  currency: string;
  total: string | number;
  status: string;
  route_id: number;
  minimum_charge: number;
  base_vehicle_id: number;
  vehicle_type_id: number;
  source_city_id: number;
  destination_city_id: number;
  city_distance_id: number;
  luggage_carrier: string;
}

interface UserRow {
  sno: number;
  userId: string;
  userType: string;
  name: string;
  companyName: string;
  vehicle: string;
  city: string;
  pendingDoc: number;
  marketplace: string;
  userStatus: string;
  loginStatus: string;
  signupStatus: string;
  createdAt: string;
  action: string;
}

interface Transaction {
  sno: number;
  date: string;
  bookingId: string;
  bookingType: string;
  creditLimit: number;
  bookingAmount: number;
  creditamount: number;
  debitamount: number;
  balance: number;
}

// Define types for the component props
interface Column {
  key: string;
  header: string;
  sortable?: boolean;
  filterable?: boolean;
  filterType?: any;
  render?: (value: any, row?: any) => React.ReactNode;
  hidden?: boolean;
}

interface RowData {
  master_package_id?: number;
  vehicle_type_id?: number;
  booking_amount?: number;
  city_id?: number;
  booking_date?: string;
}
interface ReferenceEntry {
  sno: number;
  date: string;
  refCode: string;
  refTo: string;
  amount: number;
  expiresOn: string;
}

interface AcceptBookingInterface {
  sno: number;
  itineraryId: string;
  id: string;
  pickupTime: string;
  vehicle: string;
  vendorDriver: string;
  bookingType: string;
  dutyAmount: number;
  partner: string;
  departure: string;
  dropArea: string;
  status: string;
  action: string;
}

interface RecentViewedInterface {
  sno: number;
  user: string;
  pickupDate: string;
  bookingStage: string;
  city: string;
  bookingType: string;
  particular: string;
  departure: string;
  dropArea: string;
  price: number;
  status: string | number;
  action: string;
}

interface unassignedbooking {
  sno: number;
  itinerary_id: number;
  id: string;
  pickup_time: string;
  vehicle: string;
  booking_type: string;
  duty_amount: string;
  partner: string;
  pick_up: string;
  drop_area: string;
  status: string;
  action: string;
  vehicle_model: string;
  booking_id: number;
}

interface approvalPending {
  sno: number;
  itinerary_id: number;
  id: string;
  pickup_time: string;
  vehicle: string;
  booking_type: string;
  duty_amount: string;
  partner: string;
  pick_up: string;
  drop_area: string;
  status: string;
  action: string;
  vehicle_model: string;
  booking_id: number;
}

interface ItineraryRow {
  sno: number;
  itineraryId: string;
  id: string;
  pickupDate: string;
  vehicle: string;
  driver: string;
  bookingType: string;
  dutyAmount: number;
  partner: string;
  departure: string;
  dropArea: string;
  status: string;
  action: string; // could be a button label or icon
}

interface userData {
  city_name: string;
  created_date: string;
  email: string;
  user_id: number;
  login_status: boolean;
  mobile: string;
  modified_on: string;
  name: string;
  pending_doc: string;
  signup_status: number;
  user_type: string;
  vehicle_model_names: string;
  vehicle_numbers: string;
}

const dashboardAnalyticsData = [
  {
    name: "New",
    value: 14,
    color: "bg-blue-500",
  },
  {
    name: "Personal Visit",
    value: 0,
    color: "bg-orange-500",
  },
  {
    name: "Social Media",
    value: 23,
    color: "bg-pink-500",
  },
  {
    name: "Follow-Up",
    value: 2,
    color: "bg-green-500",
  },
  {
    name: "My Referrals",
    value: 270,
    color: "bg-purple-600",
  },
];

function capitalize(str?: string) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
const Dashboard: React.FC = () => {
  const user = useAuth.getState().user;
  const { mutate: creditLimitTransaction, data: creditLimitData } =
    useGetUserCreditTrancations();
  const { data: wallet } = useGetUserWalletBalance();
  const { data: referralData } = useGetReferralPoints();
  // const { mutate: recentUserDetailMutate, data: userDetailData } =
  //   useGetRecentUserDetails();
  const { mutate: driverMutation, data: driverListData } =
    useGetDriverListRecent();
  const { mutate, data: biddingData, isError } = useBiddingMutation();
  const { mutate: recentViewedMutate, data: getRecentViewedData } =
    useRecentBookingMutation();
  const { mutate: assignedBookingMutate, data: getAssignedBookingData } =
    useAssignedBookingMutation();
  const { mutate: unAssignedBookingMutate, data: getUnAssignedBookingData } =
    useUnAssignedBookingMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRelationManagerModalOpen, setIsRelationManagerModalOpen] =
    useState(false);
  const [isUserStatusModalOpen, setIsUserStatusModalOpen] = useState(false);
  const router = useRouter();
  const [selectedBookingId, setSelectedBookingId] = useState<string | number>(
    ""
  );
  const { mutate: vendorAcceptJobMutate, data: vendorAcceptJobData } =
    useVendorAcceptedJob();
  const [selectedItineraryId, setSelectedItineraryId] = useState<string | null>(
    null
  );
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [isTripModalOpen, setIsTripModalOpen] = useState(false);
  const [recentUserId, setRecentUserId] = useState<number | null>(null);
  const [recentUserOldStatus, setRecentUserOldStatus] = useState<number>();
  const { mutate: useSendEmailMutation } = useSendUserEmail();
  const { bidForm, setBidForm, setBidData } = useBidFormStore();
  const { mutate: updateStatusMutate } = useUpdateBiddingStatus();
  const [isCommingFromItinearyClick, setIsCommingFromItinearyClick] =
    useState(false);
  const [rowData, setRowData] = useState<RowData>({
    master_package_id: 0,
    vehicle_type_id: 0,
    booking_amount: 0,
    city_id: 0,
    booking_date: "",
  });

  const fetchUserData = () => {
    driverMutation({
      user_type_id: "1,2,5,6,7,8",
      company_id: user?.company_id,
      user_id: user?.id,
    });
  };
  useEffect(() => {
    handleBiddingFetch();
    handleBookingRecent();
    handleUnAssignedBooking();
    handleAssignedBooking();
    fetchUserData();
    creditLimitTransaction({
      company_id: user?.company_id,
      user_id: user?.id,
    });
  }, []);
  const DropdownButton = ({
    icon,
    label,
    onClick = () => {},
  }: {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
  }) => (
    <button
      onClick={(e) => {
        e.stopPropagation(); // Optional: prevent dropdown from closing
        onClick();
      }}
      className="w-full flex items-center cursor-pointer gap-2 px-2 py-1 rounded hover:bg-gray-100  text-gray-700"
    >
      {icon}
      {label}
    </button>
  );

  const handleBiddingFetch = () => {
    // need to make dyanmically
    mutate({
      page: 1,
      limit: 10,
    });
  };

  // const handleRecentuserSearch = (searchTerm: string) => {
  //   recentUserDetailMutate({ name: searchTerm });
  // };

  const handleBookingRecent = () => {
    recentViewedMutate({
      user_type_id: user?.user_type_id || 0,
      page: 1,
      limit: 10,
    });
  };
  const delayedHandleBookingRecent = () => {
    setTimeout(() => {
      handleBookingRecent();
    }, 500);
  };
  const { mutate: deleteRecentlyViewedMutate, data: recentlyViewedData } =
    useDeleteRecentlyViewedMutation(delayedHandleBookingRecent);
  const { mutate: statusRecentlyViewedMutate, data: recentlyViewedStatus } =
    useStatusRecentlyViewedMutation(delayedHandleBookingRecent);

  const handleAssignedBooking = () => {
    assignedBookingMutate({
      user_type_id: user?.user_type_id || 0,
      user_id: user?.id,
      page: 1,
      limit: 10,
    });
  };
  const handleUnAssignedBooking = () => {
    unAssignedBookingMutate({
      draw: 1,
      start: 0,
      length: 10,
      order: [{ column: 0, dir: "asc" }],
      columns: [
        { data: "booking_id" },
        { data: "pickup_date" },
        { data: "city_name" },
      ],
      search: { value: "" },
      user_type_id: user?.user_type_id || 0,
      user_id: user?.id,
    });
  };
  const formatTo12Hour = (time24: string) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  const SendSMS = (row: any) => {
    toast.success("sms send successfully");
  };
  const unAssignedData: unassignedbooking[] = getUnAssignedBookingData?.map(
    (item: any, index: number) => ({
      sno: index + 1,
      itinerary_id: item.itinerary_id,
      id: item.reference_number,
      pickup_time: item?.ordertime?.split(" "),
      vehicle: item.vehicle,
      driver_name: item?.driver_name || "N/A",
      driver_mobile: item?.driver_mobile || "N/A",
      driver_id: item?.driver_id || "N/A",
      booking_type: item?.booking_type,
      approx_after_km: item?.approx_after_km || "N/A",
      duty_amount: item?.estimateprice_before_discount || 0,
      min_per_km_charge: item?.min_per_km_charge || 0,
      min_per_hr_charge: item?.min_per_hr_charge || 0,
      night_charge_price: item?.night_charge_price || 0,
      partner: item?.domain_name || "N/A",
      device_type: item.device_type || "N/A",
      pick_up: item?.pickup_area || "N/A",
      drop_area: item?.drop_area || "N/A",
      status: item?.status_name || "N/A",
      departure: item?.departure || "N/A",
      vehicle_model: item?.vehicle_model || "N/A",
      local_pkg_name: item?.local_pkg_name || "N/A",
      ref: item?.reference_number,
      booking_id: item?.id,
      driver_vehicle_type: item?.driver_vehicle_type,
      vehicle_names: item?.vehicle_names,
      vehicle_no: item?.vehicle_no || "N/A",
    })
  );

  const approvalPendingData: approvalPending[] = getUnAssignedBookingData?.map(
    (item: any, index: number) => ({
      sno: index + 1,
      itinerary_id: item.itinerary_id,
      id: item.ref,
      pickup_time: item?.ordertime?.split(" "),
      vehicle: item.vehicle,
      booking_type: item?.booking_type,
      approx_after_km: item?.approx_after_km || "N/A",
      duty_amount: item?.estimated_price_before_markup || 0,
      min_per_km_charge: item?.min_per_km_charge || 0,
      min_per_hr_charge: item?.min_per_hr_charge || 0,
      night_charge_price: item?.night_charge_price || 0,
      partner: item.domain_name || "N/A",
      device_type: item.device_type || "N/A",
      pick_up: item?.pickup_area || "N/A",
      drop_area: item?.drop_area || "N/A",
      status: item?.status_name || "N/A",
      departure: item?.departure || "N/A",
      vehicle_model: item?.vehicle_model || "N/A",
      local_package: item?.local_pkg_name || "N/A",
      ref: item?.ref,
      booking_id: item?.id,
    })
  );
  const assignedData: unassignedbooking[] = getAssignedBookingData?.map(
    (item: any, index: number) => ({
      sno: index + 1,
      itinerary_id: item.itinerary_id,
      id: item.reference_number,
      pickup_time: item?.ordertime?.split(" "),
      vehicle: item.driver_vehicle_type,
      vehicle_names: item?.vehicle_names,
      vehicle_type: item?.vehicle_type,
      booking_type: item?.booking_type,
      driver_name: item?.driver_name,
      driver_mobile: item?.driver_mobile,
      approx_after_km: item?.approx_after_km || "N/A",
      duty_amount: item?.estimateprice_before_discount || 0, // need to verify with mohit
      min_per_km_charge: item?.min_per_km_charge || 0,
      min_per_hr_charge: item?.min_per_hr_charge || 0,
      night_charge_price: item?.night_charge_price || 0,
      partner: item.domain_name || "N/A",
      device_type: item.device_type || "N/A",
      pick_up: item?.pickup_area || "N/A",
      drop_area: item?.drop_area || "N/A",
      status: item?.status_name || "N/A",
      departure: item?.departure || "N/A",
      vehicle_model: item?.vehicle_model || "N/A",
      local_package: item?.local_pkg_name || "N/A",
      ref: item?.reference_number,
      booking_id: item?.id,
      master_package_id: item?.master_package_id,
      vehicle_type_id: item?.vehicle_type_id,
      vehicle_no: item?.vehicle_no,
      city_id: item?.pickup_city,
      booking_date: item?.ordertime,
    })
  );
  const transactions: Transaction[] = [];

  if (Array.isArray(creditLimitData) && creditLimitData.length > 0) {
    let currentBalance = creditLimitData[0].credit_limit_amount || 0;

    creditLimitData.forEach((item: any, index: number) => {
      const bookingAmount = item.booking_amount || 0;
      const balance = item.credit_balance ?? currentBalance - bookingAmount;

      transactions.push({
        sno: index + 1,
        date: item.from_date || "N/A",
        bookingId: item.reference_no || "N/A",
        bookingType: item.booking_type || "N/A",
        creditLimit: currentBalance,
        bookingAmount,
        creditamount: item.creditamount || 0,
        debitamount: item.debitamount || 0,
        balance,
      });

      currentBalance = balance;
    });
  }

  const finalBalance = transactions.length
    ? transactions[transactions.length - 1].balance
    : 0;

  const formatDate = (date: Date): string =>
    `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;

  const referenceData: ReferenceEntry[] =
    referralData?.userReferralHistory?.map(
      (item: any, index: number): ReferenceEntry => {
        const createdDate = item.created ? new Date(item.created) : new Date();
        const expiresOnDate = new Date(createdDate);
        expiresOnDate.setFullYear(createdDate.getFullYear() + 1);

        return {
          sno: index + 1,
          date: formatDate(createdDate),
          refCode: referralData.referral_key,
          refTo: item.name,
          amount: item.referer_point || 0,
          expiresOn: formatDate(expiresOnDate), // formatted string
        };
      }
    ) || [];

  const columns: Column[] = [
    { key: "sno", header: "S.No", sortable: true },
    { key: "date", header: "Date", sortable: true },
    { key: "bookingId", header: "Bkg ID", sortable: true },
    { key: "bookingType", header: "Bkg Type", sortable: true },
    { key: "creditLimit", header: "Credit Limit", sortable: true },
    { key: "bookingAmount", header: "Bkg Amount", sortable: true },
    // { key: "creditamount", header: "Credit Amount", sortable: true },
    // { key: "debitamount", header: "Debit Amount", sortable: true },
    { key: "balance", header: "Balance", sortable: true },
  ];
  const walletPointscolumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true },
    { key: "date", header: "Date", sortable: true },
    { key: "refCode", header: "Ref.Code", sortable: true },
    { key: "refTo", header: "Reffered To", sortable: true },
    { key: "amount", header: "Amount", sortable: true },
    { key: "expiresOn", header: "Expires On", sortable: true },
  ];

  const tripDetailHandler = (itineraryId: string, isCommingFromI?: boolean) => {
    setSelectedItineraryId(itineraryId);
    setIsTripModalOpen(true);
    setIsCommingFromItinearyClick(isCommingFromI || false);
  };

  const onUserRecentButtonClick = (userId: number, old_status: number) => {
    setRecentUserId(userId || 0);
    setRecentUserOldStatus(old_status || 0);
    setIsUserStatusModalOpen(true);
  };

  const onRelationManagerButtonClick = (userId: number) => {
    setRecentUserId(userId || 0);
    setIsRelationManagerModalOpen(true);
  };

  const onUnassignedBookingClaim = (booking_id: number) => {
    if (!user?.id) {
      toast.error("User not found");
      return;
    }

    vendorAcceptJobMutate(
      { booking_id, id: user.id },
      {
        onSuccess: (data: any) => {
          if (data.status === "success") {
            toast.info(data?.data?.driverBalance?.message);
          } else {
            toast.error(
              data?.data?.driverBalance?.message || "Failed to claim booking"
            );
          }
          handleBiddingFetch();
        },
        onError: (error: any) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  const onAssignedBookingClaim = (rowData: any) => {
    setSelectedBookingId(rowData?.id);
    setRowData({
      master_package_id: rowData.master_package_id,
      vehicle_type_id: rowData.vehicle_type_id,
      booking_amount: rowData.duty_amount,
      city_id: rowData.city_id,
      booking_date: rowData.booking_date,
    });
    setIsModalOpen(true);
  };

  const assignedbookingColumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true },
    {
      key: "itinerary_id",
      header: "Itinerary Id",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <button
            onClick={() => tripDetailHandler(row.itinerary_id, true)}
            className="text-blue-600 hover:text-blue-800 underline "
          >
            {row.itinerary_id}
          </button>
        </div>
      ),
    },
    { key: "id", header: "Id", sortable: true },
    {
      key: "pickup_time",
      header: "Pickup Time",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">
            {Array.isArray(row?.pickup_time) ? row.pickup_time[0] : "N/A"}
          </div>
          <div className="font-medium">
            {Array.isArray(row?.pickup_time) && row.pickup_time[1]
              ? formatTo12Hour(row.pickup_time[1])
              : "N/A"}
          </div>
        </div>
      ),
    },
    {
      key: "vehicle",
      header: "Vehicle",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row?.vehicle}</div>
          <div
            className=" text-gray-600 truncate max-w-[100px]"
            title={row?.vehicle_names}
          >
            <div>{row?.vehicle_type || "N/A"}</div>
            <div>{row?.vehicle_names || "N/A"}</div>
          </div>
        </div>
      ),
    },
    {
      key: "driver",
      header: "Driver",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row?.driver_name || "N/A"}</div>
          <div className="text-gray-600">{row?.driver_mobile || "N/A"}</div>

          <div
            className="text-gray-600 truncate max-w-[120px]"
            title={row?.driver_vehicle_type}
          >
            {row?.driver_vehicle_type || "N/A"}
          </div>

          <div className="text-gray-600">{row?.vehicle_no || "N/A"}</div>
        </div>
      ),
    },

    {
      key: "booking_type",
      header: "Booking Type",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.booking_type}</div>
          <div>{row.local_package}</div>
          <div>
            {" "}
            <span className="font-medium"> Distance: </span>
            {row.approx_after_km}
          </div>
          <button
            onClick={() => tripDetailHandler(row.itinerary_id)}
            className="text-blue-600 hover:text-blue-800 underline "
          >
            Trip Detail
          </button>
        </div>
      ),
    },
    {
      key: "duty_amount",
      header: "Duty Amount",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>
            {" "}
            <span className="font-medium"> Duty Amount: </span>₹{" "}
            {row.duty_amount}
          </div>
          <div>
            {" "}
            <span className="font-medium"> Extra KM: </span>₹
            {row.min_per_km_charge}
          </div>
          <div>
            {" "}
            <span className="font-medium"> Extra HR: </span>₹
            {row.min_per_hr_charge}
          </div>
          <div>
            <span className="font-medium"> DA: </span> ₹{row.night_charge_price}
          </div>
        </div>
      ),
    },
    {
      key: "partner",
      header: "Partner",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>{row.partner}</div>
          <div>{row.device_type}</div>
        </div>
      ),
    },
    {
      key: "departure",
      header: "Departure",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className="text-gray-600 truncate max-w-[80px]"
            title={row.departure}
          >
            {row.departure}
          </div>
        </div>
      ),
    },
    {
      key: "drop_area",
      header: "Drop Area",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[80px] "
            title={row.drop_area}
          >
            {row.drop_area}
          </div>
        </div>
      ),
    },
    {
      key: "status",
      header: "Status",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[40px] "
            title={row.status}
          >
            {row?.status}
          </div>
        </div>
      ),
    },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (value: string, row: any) => (
        <div className="flex flex-col space-y-1">
          <button
            onClick={() => onAssignedBookingClaim(row)}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Claim
          </button>

          <button
            onClick={() => SendSMS(row)}
            className="text-green-600 hover:text-green-800 font-medium"
          >
            Send SMS
          </button>
        </div>
      ),
    },
    { key: "booking_id", header: "booking_id", sortable: false, hidden: true },
    {
      key: "master_package_id",
      header: "master_package_id",
      sortable: false,
      hidden: true,
    },
    {
      key: "vehicle_type_id",
      header: "vehicle_type_id",
      sortable: false,
      hidden: true,
    },
    {
      key: "city_id",
      header: "city_id",
      sortable: false,
      hidden: true,
    },
    {
      key: "booking_date",
      header: "booking_date",
      sortable: false,
      hidden: true,
    },
  ];

  const unassignedbookingColumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true, filterable: true },
    {
      key: "itinerary_id",
      header: "Itinerary Id",
      sortable: true,
      filterable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <button
            onClick={() => tripDetailHandler(row.itinerary_id, true)}
            className="text-blue-600 hover:text-blue-800 underline "
          >
            {row.itinerary_id}
          </button>
        </div>
      ),
    },
    { key: "id", header: "Id", sortable: true, filterable: true },
    {
      key: "pickup_time",
      header: "Pickup Time",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.pickup_time[0]}</div>
          <div className="font-medium">
            {formatTo12Hour(row.pickup_time[1])}
          </div>
        </div>
      ),
    },
    {
      key: "vehicle",
      header: "Vehicle",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.vehicle}</div>
          <div
            className=" text-gray-600 wrap-text truncate max-w-[100px]"
            title={row.vehicle_names}
          >
            <div>{row.vehicle_type || "N/A"}</div>
            <div>{row.vehicle_names || "N/A"}</div>
          </div>
        </div>
      ),
    },
    {
      key: "driver",
      header: "Driver",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row?.driver_name || "N/A"}</div>
          <div className="text-gray-600">{row?.driver_mobile || "N/A"}</div>

          <div
            className="text-gray-600 truncate max-w-[120px]"
            title={row?.driver_vehicle_type}
          >
            {row?.driver_vehicle_type || "N/A"}
          </div>

          <div className="text-gray-600">{row?.vehicle_no || "N/A"}</div>
        </div>
      ),
    },
    {
      key: "local_pkg_name",
      header: "Booking Type",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.local_pkg_name}</div>
          <div>{row.local_pkg_name}</div>
          <div>
            {" "}
            <span className="font-medium"> Distance: </span>
            {row.approx_after_km}
          </div>
          <button
            onClick={() => tripDetailHandler(row.itinerary_id)}
            className="text-blue-600 hover:text-blue-800 underline text-[12px]"
          >
            Trip Detail
          </button>
        </div>
      ),
    },
    {
      key: "duty_amount",
      header: "Duty Amount",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>
            {" "}
            <span className="font-medium"> Duty Amount: </span>₹{" "}
            {row.duty_amount}
          </div>
          <div>
            {" "}
            <span className="font-medium"> Extra KM: </span>₹
            {row.min_per_km_charge}
          </div>
          <div>
            {" "}
            <span className="font-medium"> Extra HR: </span>₹
            {row.min_per_hr_charge}
          </div>
          <div>
            <span className="font-medium"> DA: </span> ₹{row.night_charge_price}
          </div>
        </div>
      ),
    },
    {
      key: "partner",
      header: "Partner",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>{row.partner}</div>
          <div>{row.device_type}</div>
        </div>
      ),
    },
    {
      key: "departure",
      header: "Departure",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[80px]"
            title={row.departure}
          >
            {row.departure}
          </div>
        </div>
      ),
    },
    {
      key: "drop_area",
      header: "Drop Area",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className="text-gray-600 truncate max-w-[80px] "
            title={row.drop_area}
          >
            {row.drop_area}
          </div>
        </div>
      ),
    },
    {
      key: "status",
      header: "Status",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className="text-gray-600 truncate max-w-[40px] "
            title={row.status}
          >
            {row?.status}
          </div>
        </div>
      ),
    },
    // { key: "status", header: "Status", sortable: true },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (value: string, row: any) => (
        <button
          onClick={() => onUnassignedBookingClaim(row?.booking_id)}
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Accept
        </button>
      ),
    },
    { key: "booking_id", header: "booking_id", sortable: false, hidden: true },
  ];

  const approvalPendingColumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true, filterable: true },
    {
      key: "itinerary_id",
      header: "Itinerary Id",
      sortable: true,
      filterable: true,
    },
    { key: "id", header: "Id", sortable: true, filterable: true },
    {
      key: "pickup_time",
      header: "Pickup Time",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.pickup_time[0]}</div>
          <div className="font-medium">
            {formatTo12Hour(row.pickup_time[1])}
          </div>
        </div>
      ),
    },
    {
      key: "vehicle",
      header: "Vehicle",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.vehicle}</div>
          <div
            className=" text-gray-600 truncate max-w-[100px]"
            title={row.vehicle_names}
          >
            <div>{row.vehicle_type || "N/A"}</div>
            <div>{row.vehicle_names || "N/A"}</div>
          </div>
        </div>
      ),
    },
    { key: "driver", header: "Driver", sortable: true },
    {
      key: "booking_type",
      header: "Booking Type",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div className="font-medium">{row.booking_type}</div>
          <div>{row.local_package}</div>
          <div>
            {" "}
            <span className="font-medium"> Distance: </span>
            {row.approx_after_km}
          </div>
          <button
            onClick={() => tripDetailHandler(row.itinerary_id)}
            className="text-blue-600 hover:text-blue-800 underline "
          >
            Trip Detail
          </button>
        </div>
      ),
    },
    {
      key: "duty_amount",
      header: "Duty Amount",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>
            {" "}
            <span className="font-medium"> Duty Amount: </span>₹{" "}
            {row.duty_amount}
          </div>
          <div>
            {" "}
            <span className="font-medium"> Extra KM: </span>₹
            {row.min_per_km_charge}
          </div>
          <div>
            {" "}
            <span className="font-medium"> Extra HR: </span>₹
            {row.min_per_hr_charge}
          </div>
          <div>
            <span className="font-medium"> DA: </span> ₹{row.night_charge_price}
          </div>
        </div>
      ),
    },
    {
      key: "partner",
      header: "Partner",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>{row.partner}</div>
          <div>{row.device_type}</div>
        </div>
      ),
    },
    {
      key: "departure",
      header: "Departure",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[80px]"
            title={row.departure}
          >
            {row.departure}
          </div>
        </div>
      ),
    },
    {
      key: "drop_area",
      header: "Drop Area",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[80px] "
            title={row.drop_area}
          >
            {row.drop_area}
          </div>
        </div>
      ),
    },
    {
      key: "status",
      header: "Status",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[40px] "
            title={row.status}
          >
            {row?.status}
          </div>
        </div>
      ),
    },
    // { key: "status", header: "Status", sortable: true },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (value: string, row: any) => (
        <button
          onClick={() => onUnassignedBookingClaim(row?.booking_id)}
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          Accept
        </button>
      ),
    },
    { key: "booking_id", header: "booking_id", sortable: false, hidden: true },
  ];

  const itineraryColumns: any = [
    { key: "sno", header: "S.No", sortable: true, filterable: true },
    {
      key: "itineraryId",
      header: "Itinerary Id",
      sortable: true,
      filterable: true,
    },
    { key: "id", header: "Id", sortable: true, filterable: true },
    {
      key: "pickupDate",
      header: "Pickup Date",
      sortable: true,
      filterType: "daterange",
      filterable: true,
    },
    { key: "vehicle", header: "Vehicle", sortable: true, filterable: true },
    {
      key: "driver",
      header: "Driver",
      sortable: true,
      filterType: "multiselect",
      filterable: true,
    },
    {
      key: "bookingType",
      header: "Booking Type",
      sortable: true,
      filterable: true,
    },
    {
      key: "dutyAmount",
      header: "Duty Amount",
      sortable: true,
      filterType: "range",
      filterable: true,
    },
    {
      key: "partner",
      header: "Partner",
      sortable: true,
      filterType: "multiselect",
      filterable: true,
    },
    { key: "departure", header: "Departure", sortable: true, filterable: true },
    { key: "dropArea", header: "Drop Area", sortable: true, filterable: true },
    {
      key: "status",
      header: "STATUS",
      sortable: true,
      render: (value: string) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${
            value === "Completed"
              ? "bg-green-100 text-green-800"
              : value === "Upcoming"
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {value}
        </span>
      ),
    },
    {
      key: "action",
      header: "ACTION",
      sortable: false,
      filterable: false,
      render: (value: string, row: any) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            alert(`Viewing ${row.bookingReference}`);
          }}
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          {value}
        </button>
      ),
    },
  ];
  const AcceptBooking: Column[] = [
    { key: "sno", header: "S.No.", sortable: true },
    { key: "itineraryId", header: "Itinerary Id", sortable: true },
    { key: "id", header: "Id", sortable: true },
    { key: "pickupTime", header: "Pickup Time", sortable: true },
    { key: "vehicle", header: "Vehicle", sortable: true },
    { key: "vendorDriver", header: "Vendor / Driver", sortable: true },
    { key: "bookingType", header: "Booking Type", sortable: true },
    { key: "dutyAmount", header: "Duty Amount", sortable: true },
    { key: "partner", header: "Partner", sortable: true },
    { key: "departure", header: "Departure", sortable: true },
    { key: "dropArea", header: "Drop Area", sortable: true },
    {
      key: "status",
      header: "Status",
      sortable: true,
      render: (value: string) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${
            value === "Completed"
              ? "bg-green-100 text-green-800"
              : value === "Ongoing"
              ? "bg-yellow-100 text-yellow-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {value}
        </span>
      ),
    },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (value: string, row: any) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            alert(`Viewing Itinerary ${row.itineraryId}`);
          }}
          className="text-blue-600 hover:text-blue-800 font-medium"
        >
          {value}
        </button>
      ),
    },
  ];

  const recentViewedData = getRecentViewedData?.results;
  const RecentViewedBookingData: RecentViewedInterface[] = Array.isArray(
    recentViewedData
  )
    ? recentViewedData.map((item: any, index: number) => {
        let bookingData: any = {};
        try {
          bookingData = JSON.parse(item.booking_data || "{}");
        } catch (error) {
          console.error("Invalid booking_data JSON:", error);
        }

        return {
          sno: index + 1,
          user: `${item?.first_name || ""} ${item?.last_name || ""}\n${
            item?.email || ""
          }\n${item?.mobile || ""}`,
          pickupDate: bookingData?.pickup_date || "N/A",
          bookingStage: item.booking_stage,
          city: bookingData?.pickup_city || "Unknown",
          bookingType: bookingData?.master_package_type || "N/A",
          particular: bookingData?.pickup_area || "N/A",
          departure: bookingData.pickup_time || "N/A",
          dropArea: bookingData.pickup_address || "N/A",
          price: bookingData.total_price ,
          status: item.status == 1 ? "active" : "in-active",
          action: "View",
          first_name: item?.first_name,
          last_name: item?.last_name,
          email: item?.email,
          mobile: item?.mobile,
        };
      })
    : [];

  const onRecentBookingActionHandler = (
    type: string,
    id: number,
    status: number | string,
    data?: BidListingRow
  ) => {
    const val = status == "active" ? 1 : 0;

    // handleBookingRecent();
  };

  const onBidHandler = (
    type: string,
    id: number,
    status: number,
    data: BidListingRow
  ) => {
    if (type == "delete") {
      updateStatusMutate(
        {
          status: status,
          bid_id: [id],
        },
        {
          onSuccess: (data) => {
            if (data.status == "success") {
              toast.success(data.message);
            }
            handleBiddingFetch();
          },
          onError: (error) => {
            toast.error("Something went wrong");
          },
        }
      );
    } else {
      setBidData(data);
      router.push("/bidding");
      setBidForm("AddBidForm");
      statusRecentlyViewedMutate({ id: id, status: status });
    }
  };

  const recentViewedBookingColumn: Column[] = [
    { key: "sno", header: "S.No", sortable: true },
    {
      key: "user",
      header: "User",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div>
            {" "}
            <span className="font-medium"> </span>{" "}
            {row.first_name + "" + row.last_name}
          </div>
          <div>
            {" "}
            <span className="font-medium"> </span>
            {row.email}
          </div>
          <div>
            {" "}
            <span className="font-medium"> </span>
            {row.mobile}
          </div>
        </div>
      ),
    },
    { key: "pickupDate", header: "Pickup Date", sortable: true },
    { key: "bookingStage", header: "Booking Stage", sortable: true },
    { key: "city", header: "City", sortable: true },
    { key: "bookingType", header: "Booking Type", sortable: true },
    { key: "particular", header: "Particular", sortable: true },
    { key: "departure", header: "Departure", sortable: true },
    {
      key: "dropArea",
      header: "Drop Area",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div
            className=" text-gray-600 truncate max-w-[80px] "
            title={row.dropArea}
          >
            {row.dropArea}
          </div>
        </div>
      ),
    },
    { key: "price", header: "Price", sortable: true },
    { key: "status", header: "Status", sortable: true },
    // {
    //   key: "action",
    //   header: "Action",
    //   sortable: false,
    //   render: (_: string, row: any) => (
    //     <div>
    //       <button
    //         onClick={(e) => {
    //           onRecentBookingActionHandler("inactive", row?.sno, row?.status);
    //         }}
    //         className="text-blue-600 hover:text-blue-800 cursor-pointer"
    //       >
    //         {row?.status == 0 ? "active" : "In-Active"}
    //       </button>
    //       <div>
    //         <button
    //           onClick={(e) => {
    //             onRecentBookingActionHandler("delete", row?.sno, row?.status);
    //           }}
    //           className="text-blue-600 hover:text-blue-800 cursor-pointer"
    //         >
    //           Delete
    //         </button>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (_: string, row: any) => (
        <div className="flex flex-col items-start space-y-1">
          <button
            onClick={() =>
              onRecentBookingActionHandler("inactive", row?.sno, row?.status)
            }
            className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
          >
            <SquareCheckBig className="w-4 h-4" />
            {row?.status == 0 ? "Active" : "Inactive"}
          </button>

          <button
            onClick={() =>
              onRecentBookingActionHandler("delete", row?.sno, row?.status)
            }
            className="text-red-600 hover:text-red-800 flex items-center gap-1"
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        </div>
      ),
    },
  ];
  const bidListingColumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true },
    { key: "sourceCity", header: "S. City", sortable: true },
    { key: "destinationCity", header: "D. City", sortable: true },
    { key: "distanceKm", header: "Distance (km)", sortable: true },
    { key: "vehicleType", header: "Vehicle Type", sortable: true },
    { key: "package", header: "Package", sortable: true },
    { key: "packageMode", header: "Mode", sortable: true },
    { key: "minCharge", header: "Min Charge", sortable: true },
    { key: "minDistance", header: "Min Distance", sortable: true },
    { key: "perKmCharge", header: "Per Km Charge", sortable: true },
    { key: "startTime", header: "Start Time", sortable: true },
    { key: "endTime", header: "End Time", sortable: true },
    { key: "fromDate", header: "From Date", sortable: true },
    { key: "toDate", header: "To Date", sortable: true },
    { key: "base_vehicle_id", header: "", hidden: true },
    { key: "vehicle_type_id", header: "", hidden: true },
    { key: "minimum_charge", header: "", hidden: true },
    { key: "source_city_id", header: "", hidden: true },
    { key: "destination_city_id", header: "", hidden: true },
    { key: "city_distance_id", header: "", hidden: true },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (_: string, row: any) => (
        <div className="flex items-start gap-2 space-y-1">
          <button
            onClick={() =>
              onBidHandler("edit", row?.route_id, row?.status, row)
            }
            className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
          >
            <SquarePen className="w-4 h-4" />
            Edit
          </button>

          <button
            onClick={() => onBidHandler("delete", row?.route_id, 2, row)}
            className="text-red-600 hover:text-red-800 flex items-center gap-1"
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rawData = biddingData;
  const bidListingData: BidListingRow[] = Array.isArray(rawData)
    ? rawData.map((item: any, index: number) => ({
        sno: index + 1,
        sourceCity: item.source_city_name,
        destinationCity: item.destination_city_name,
        distanceKm: item.distance_km,
        vehicleType: item.vehicle_type,
        package: item.package_name,
        packageMode: item.package_mode,
        minCharge: item.minimum_charge,
        minDistance: item.minimum_distance ?? 100,
        perKmCharge: item.per_km_charge ?? 999,
        startTime: item.start_time,
        endTime: item.end_time,
        fromDate: formatDate(new Date(item.from_date)),
        toDate: formatDate(new Date(item.to_date)),
        fare: item.fare,
        extraKm: item.extraKm,
        toll: item.toll,
        parking: item.parking,
        da: item.driver_allowance,
        currency: item.currency,
        total: 0,
        status: item.status,
        route_id: item.route_id,
        base_vehicle_id: item.base_vehicle_id,
        vehicle_type_id: item.vehicle_type_id,
        minimum_charge: item.minimum_charge,
        source_city_id: item.source_city_id,
        destination_city_id: item.destination_city_id,
        city_distance_id: item.city_distance_id,
        luggage_carrier: item.luggage_carrier,
        action: "View",
      }))
    : [];

  const userData = useMemo(() => {
    const rawData = driverListData?.data;
    return Array.isArray(rawData)
      ? rawData.map((item: any, index: number) => ({
          sno: index + 1,
          city_name: item.city_name,
          created_date: formatDate(new Date(item.created_date)),
          email: item.email,
          user_id: item.user_id,
          login_status: item.login_status,
          mobile: item.mobile,
          modified_on: item.modified_on,
          name: item.name,
          pending_doc: item.pending_doc,
          signup_status: item.signup_status,
          user_type: item.user_type,
          vehicle_name: item.vehicle_name || "N/A",
          vehicle_no: item.vehicle_no || "N/A",
          old_status: item.isActive,
          action: "View",
          
          country_name: item.country_name,
          IsActive: item.isActive,
          
        }))
      : [];
  }, [driverListData]);

  const onUpdateClick = (user_id: number, status_id: number) => {
    const status = [
      { id: "0", label: "Offline" },
      { id: "1", label: "Active" },
      { id: "2", label: "On Hold" },
      { id: "3", label: "Black Listed" },
      { id: "4", label: "Inactive" },
      { id: "5", label: "Unapproved" },
      { id: "6", label: "Deleted" },
    ];
    const currentStatus = status.find((s) => s.id === String(status_id));
    useSendEmailMutation(
      {
        user_id,
        status: currentStatus?.label,
      },
      {
        onSuccess: (data) => {
          if (data.status == "success") {
            toast.success(data.message);
          }
        },
        onError: (error) => {
          toast.error("Something want wrong");
        },
      }
    );
  };

  const onRecentUserEdit = (user_id: any) => {
    router.push(`/profile?user_id=${encodeURIComponent(user_id)}&type=edit`);
  };
  const userColumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true },
    { key: "user_id", header: "User Id", sortable: true },
    { key: "user_type", header: "User Type", sortable: true },
    {
      key: "name",
      header: "Name",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div> {row.name}</div>
          <div> {row.mobile}</div>
          <div> {row.email}</div>
        </div>
      ),
    },
    // { key: "companyName", header: "Company Name", sortable: true },
    {
      key: "vehicle",
      header: "Vehicle",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="space-y-1">
          <div> {row.vehicle_name}</div>
          <div> {row.vehicle_no}</div>
          {/* <div> {row.email}</div>   need to add*/}
        </div>
      ),
    },
    { key: "city_name", header: "City", sortable: true },
    {
      key: "pending_doc",
      header: "Pending Doc",
      sortable: true,
      render: (value: string) => {
        const docs = value?.split(",") || [];
        return (
          <div className="max-h-24 overflow-y-auto p-1 bg-gray-50 rounded  space-y-1">
            {docs.map((doc, index) => (
              <div key={index} className="whitespace-nowrap">
                {doc.trim()}
              </div>
            ))}
          </div>
        );
      },
    },

    {
      key: "marketplace",
      header: "Marketplace",
      sortable: true,
      render: (_: string, row: any) => (
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full bg-green-500" />
          <span>{row.marketplace}</span>
        </div>
      ),
    },
    {
      key: "old_status",
      header: "User Status",
      sortable: true,
      render: (value: number | string) => {
        const isOnline = Number(value) !== 0;
        const status = [
          { id: "0", label: "Offline" },
          { id: "1", label: "Active" },
          { id: "2", label: "On Hold" },
          { id: "3", label: "Black Listed" },
          { id: "4", label: "Inactive" },
          { id: "5", label: "Unapproved" },
          { id: "6", label: "Deleted" },
        ];
        const currentStatus = status.find((s) => s.id === String(value));
        return (
          <div className="flex items-center gap-2">
            <span
              className={`h-2.5 w-2.5 rounded-full ${
                isOnline ? "bg-green-500" : "bg-red-500"
              }`}
            />
            <span className=" font-medium">
              {currentStatus?.label || "Unknown"}
            </span>
          </div>
        );
      },
    },
    {
      key: "login_status",
      header: "Login Status",
      sortable: true,
      render: (value: number | string) => {
        const isOnline = Number(value) !== 0;

        return (
          <div className="flex items-center gap-2">
            <span
              className={`h-2.5 w-2.5 rounded-full ${
                isOnline ? "bg-green-500" : "bg-red-500"
              }`}
            />
            <span className=" font-medium">
              {isOnline ? "Online" : "Offline"}
            </span>
          </div>
        );
      },
    },
    {
      key: "signup_status",
      header: "Signup Status",
      sortable: true,
      render: (value: any) => {
        const numericValue = Number(value);
        const isCompleted = !isNaN(numericValue) && numericValue >= 4;

        return (
          <div className="flex items-center gap-2">
            <span
              className={`h-2.5 w-2.5 rounded-full ${
                isCompleted ? "bg-green-500" : "bg-yellow-500"
              }`}
            />
            <span className=" font-medium">
              {isCompleted ? "Completed" : "Pending"}
            </span>
          </div>
        );
      },
    },

    { key: "created_date", header: "Created At", sortable: true },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (_: string, row: any) => {
        const isExpanded = expandedRow === row.user_id;

        return (
          <div className="relative inline-block text-left">
            {/* View Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setExpandedRow(isExpanded ? null : row.user_id);
              }}
              className="flex items-center gap-1 px-3 py-1 text-[10px] bg-blue-100 text-blue-700 hover:bg-blue-200 rounded outline-none "
            >
              <Eye className="h-4 w-4" />
              View
            </button>

            {/* Dropdown Panel */}
            {isExpanded && (
              <div className="absolute right-0 z-10 mt-2 w-56 bg-white border border-gray-200 rounded shadow-lg p-2 space-y-1">
                <DropdownButton
                  icon={<Edit className="h-4 w-4" />}
                  label="Edit"
                  onClick={() => onRecentUserEdit(row.user_id)}
                />
                <DropdownButton
                  icon={<User className="h-4 w-4" />}
                  label="Profile"
                  onClick={() => onRecentUserEdit(row.user_id)}
                />
                <DropdownButton
                  icon={<ToggleRight className="h-4 w-4" />}
                  label="Status"
                  onClick={() =>
                    onUserRecentButtonClick(row.user_id, row.old_status)
                  }
                />
                <DropdownButton
                  icon={<Users className="h-4 w-4" />}
                  label="Relation Manager"
                  onClick={() => onRelationManagerButtonClick(row.user_id)}
                  // onClick={() => setIsRelationManagerModalOpen(true)}
                />
                <DropdownButton
                  icon={<CreditCard className="h-4 w-4" />}
                  label="Credit Limit"
                />
                <DropdownButton
                  icon={<RefreshCcw className="h-4 w-4" />}
                  label="Update Status"
                  onClick={() => onUpdateClick(row.user_id, row.old_status)}
                />
              </div>
            )}
          </div>
        );
      },
    },
  ];
  const accordionItems = [
    {
      id: "bookings",
      title: "Recent Bookings",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={unAssignedData}
            columns={unassignedbookingColumns}
            searchable={true}
            filterable={true}
            sortable={false}
          />
        </div>
      ),
      defaultOpen: true,
    },
    {
      id: "approvalPending",
      title: "Approval Pending",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={unAssignedData}
            columns={unassignedbookingColumns}
            searchable={true}
            filterable={true}
            sortable={false}
          />
        </div>
      ),
      defaultOpen: true,
    },
    {
      id: "unassignedbooking",
      title: "Unassigned Booking",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={unAssignedData}
            columns={unassignedbookingColumns}
            searchable={true}
            filterable={true}
            sortable={false}
          />
        </div>
      ),
    },
    {
      id: "acceptedbooking",
      title: "Accepted Booking",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={assignedData}
            columns={assignedbookingColumns}
            searchable={false}
            filterable={false}
            sortable={false}
          />
        </div>
      ),
    },
    {
      id: "recentviewedbooking",
      title: "Recent Viewed Booking",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={RecentViewedBookingData}
            columns={recentViewedBookingColumn}
            searchable={false}
            filterable={false}
            sortable={false}
          />
        </div>
      ),
    },

    {
      id: "bidlisting",
      title: "Bid Listing",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={bidListingData}
            columns={bidListingColumns}
            searchable={false}
            filterable={false}
            sortable={false}
          />
        </div>
      ),
    },
    {
      id: "recentusers",
      title: "Recent Users",
      icon: <Inbox size={18} />,
      content: (
        <div className="space-y-3 pt-2">
          <BookingTable
            data={userData}
            columns={userColumns}
            searchable={false}
            filterable={false}
            sortable={false}
          />
        </div>
      ),
    },
  ];
  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 py-4 px-4">
      {/* Header */}
      {/* <header className="max-w-6xl mx-auto flex justify-between items-center mb-8">
        <h1 className="text-2xl font-semibold">
          Welcome,{" "}
          {user?.first_name && user?.last_name
            ? `${capitalize(user.first_name)} ${capitalize(user.last_name)}`
            : "User"}
        </h1>
      </header> */}

      {/* Cards Row */}

      <div className="w-full bg-gray-200 rounded-md h-[45px] mb-4 flex items-center px-4">
        <span className="text-gray-600 text-[12px] font-[200] sm:">
          2-Step Verification Add OTP Security Options.{" "}
          <Link className="underline text-gray-900" href="/">
            Click Here
          </Link>
        </span>
      </div>
      <section className="max-w-8xl mx-auto grid">
        <DashboardAnalytics />
        <DashboardScore />

        <section className="w-full grid gap-5 mb-5 grid-cols-6">
          {dashboardAnalyticsData.map(({ name, value, color }, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded p-2 flex items-center gap-4 w-full h-[65px]"
            >
              <span className={`${color} p-2 text-white rounded-full`}>
                <TrendingUp className="w-5 h-5" />
              </span>

              <div className="flex flex-col">
                <h1 className="text-[14px]">{value}</h1>
                <span className="text-[14px] text-gray-500">{name}</span>
              </div>
            </div>
          ))}
        </section>
        <div className="grid grid-cols-4 xl:grid-cols-4 gap-3">
          <div className="flex flex-col h-full">
            <div className="flex-grow bg-white p-4 rounded shadow h-full">
              <UserByCountry />
            </div>
          </div>
          <div className="flex flex-col h-full">
            <div className="flex-grow bg-white p-4 rounded shadow h-full">
              <TopUsers />
            </div>
          </div>
          <div className="flex flex-col h-full">
            <div className="flex-grow bg-white p-4 rounded shadow h-full">
              <PerformanceAnalytics />
            </div>
          </div>
          <div className="flex flex-col h-full">
            <div className="flex-grow bg-white p-4 rounded shadow h-full">
              <SourceWiseLeadScore />
            </div>
          </div>
        </div>
      </section>

      <section className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <BookingTable
            data={transactions}
            columns={columns}
            heading={[
              { heading: "Credit Balance" },
              { price: `₹ ${finalBalance}` },
            ]}
            searchable={false}
            filterable={false}
            sortable={false}
          />
        </div>
        <div>
          <BookingTable
            data={referenceData}
            columns={walletPointscolumns}
            heading={[
              { heading: "(Referral ID) Wallet Point 12" },
              { price: `₹ ${referralData?.referral_point || 0}` },
            ]}
            searchable={false}
            filterable={false}
            sortable={false}
          />
        </div>
      </section>

      <section className="mt-4 max-w-8xl mx-auto grid  gap-6">
        <Accordion items={accordionItems} />
      </section>
      <ClaimBookingModal
        isOpen={isModalOpen}
        bookingId={selectedBookingId}
        onClose={() => setIsModalOpen(false)}
        rowData={rowData}
      />
      <UserStatusUpdateModal
        isOpen={isUserStatusModalOpen}
        userId={recentUserId || -1}
        onClose={() => setIsUserStatusModalOpen(false)}
        oldStatus={recentUserOldStatus}
      />
      <TripDetailModal
        isOpen={isTripModalOpen}
        onClose={() => setIsTripModalOpen(false)}
        itinearyId={selectedItineraryId || ""}
        isCommingFromItineary={isCommingFromItinearyClick}
      />
      <RelationManagerModal
        isOpen={isRelationManagerModalOpen}
        userId={recentUserId || -1}
        onClose={() => setIsRelationManagerModalOpen(false)}
      />
    </div>
  );
};

export default Dashboard;
